"use client"

import React, { useEffect } from "react"
import { AppContainer } from "@src/components"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import BannerSection from "./banner-section"
import TitleSection from "./title-section"
import RelativeProduct from "@src/sections/product-list/relative-product"
import { useLayoutEffect } from "react"
import DangerouslySetInnerHTML from "@src/components/DangerouslySetInnerHTML"
import tocbot from 'tocbot'
import { useResponsive } from "@src/hooks"
import TOCSticky from "@src/components/TocSticky"

import 'tocbot/dist/tocbot.css';


interface ProductBlog {
  id: number
  image: string
  name: string
  title: string
  promotion_price: string
  sale_price: string
  slug: string
}

const formatProducts = (products: ProductBlog[]) => {
  return products.map(product => {
    const { id, image, name, title, promotion_price, sale_price, slug } = product || {}
    return {
      name: name || title,
      promotion_price: promotion_price || "",
      sale_price: sale_price || "",
      is_new: false,
      discount_percent: "",
      image: image,
      images: [],
      slug: slug
    }
  })
}

const CollectionDetail = ({ detail, relatedProducts }) => {
  const { id, image, title, description, content, slug, likes, author_name, publish_date } = detail || {}

  const { isMobile } = useResponsive()

  const parsedProducts = formatProducts(relatedProducts)

  useEffect(() => {
    // scroll to top smooth
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }, [])

  useLayoutEffect(() => {
    tocbot.init({
      tocSelector: '.toc',
      contentSelector: '.js-toc-content',
      headingSelector: 'h1, h2, h3',
      activeLinkClass: 'is-active-link',
      listClass: 'toc-list',
      collapseDepth: 3,
      // hasInnerContainers: true,
      headingsOffset: 40,
      scrollSmoothOffset: isMobile ? -80 : -150,
    })

    tocbot.refresh();
    return () => {
      tocbot.destroy()
    }
  }, [])

  return (
    <AppContainer
      sx={{
        backgroundColor: "#fff",
        padding: "0 !important"
      }}
      maxWidth={false}
    >
      <TOCSticky />
      <Stack
        gap="24px"
        direction="column"
        margin="0px auto"
        paddingX="16px"
        maxWidth="1064px"
      >

        <TitleSection
          slug={slug}
          title={title}
          description={description}
          collectionId={id}
          likes={likes}
          author_name={author_name}
          publish_date={publish_date}
        />
        <Box my="16px">
          <BannerSection imgSrc={image?.path_with_domain || ""} name={title} />
        </Box>
        <Box className="article-container container-lg">
          <Box className="article-sidebar" mb="24px" sx={{
            backgroundColor: "#F9F9F9",
            borderRadius: "8px",
            padding: "16px",
          }}>
            <Typography sx={{
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "32px",
              marginBottom: "12px"
            }}>
              Nội dung
            </Typography>
            <nav className="toc js-toc">
            </nav>
          </Box>
          <DangerouslySetInnerHTML className="js-toc-content" html={content} />
        </Box>
      </Stack>



    </AppContainer >
  )
}
export default CollectionDetail
